import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import './scss/style.scss';
import { translate } from 'react-i18next';
import { Box, TextField } from '@mui/material';
import { getFormatedDate } from '../../helpers/fotmatDate';
import $ from 'jquery';

function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
function saveFile(name, type, data) {
    if (data !== null && navigator.msSaveBlob)
        return navigator.msSaveBlob(new Blob([data], { type: type }), name);
    var a = $("<a style='display: none;'/>");
    var url = window.URL.createObjectURL(new Blob([data], { type: type }));
    a.attr("href", url);
    a.attr("download", name);
    $("body").append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
}

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        display: 'inline-block',
        maxHeight: '100vh',
        overflow: 'auto',
    },
}));

function GuaranteeDetailsModal({ item, open, t, closeFunction }) {
    const classes = useStyles();
    return (
        <Modal
            open={open}
            onClose={closeFunction}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            classes={classes.modal}
            aria-labelledby="spring-modal-title"
            aria-describedby="spring-modal-description">
            <Fade in={open}>
                <div className="feedback-modal" style={{ maxWidth: '964px', maxHeight: '90vh', overflowY: 'auto', backgroundColor: 'white', minWidth: '55%' }}>
                    <button className="asan-verificatiion-modal-close-button" onClick={closeFunction}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.67762 7.97496L14.8357 2.86698L15.8873 1.81534C16.0376 1.6651 16.0376 1.41471 15.8873 1.2144L14.7856 0.112676C14.5853 -0.0375587 14.3349 -0.0375587 14.1847 0.112676L8.02504 6.32238L1.81534 0.112676C1.6651 -0.0375587 1.41471 -0.0375587 1.2144 0.112676L0.112676 1.2144C-0.0375587 1.41471 -0.0375587 1.6651 0.112676 1.81534L6.32238 7.97496L0.112676 14.1847C-0.0375587 14.3349 -0.0375587 14.5853 0.112676 14.7856L1.2144 15.8873C1.41471 16.0376 1.6651 16.0376 1.81534 15.8873L8.02504 9.67762L13.133 14.8357L14.1847 15.8873C14.3349 16.0376 14.5853 16.0376 14.7856 15.8873L15.8873 14.7856C16.0376 14.5853 16.0376 14.3349 15.8873 14.1847L9.67762 7.97496Z" fill="#2E3131" />
                        </svg>
                    </button>
                    <div className="dashboard-account-container-component dashboard-contact-section-form">
                        <h4>{t('Guarantee details')}</h4>
                        <Box className='dashboard-account-container-component-block invoice mb-3'>
                            <TextField variant="outlined" value={item?.warrantyCategory} sx={{ width: 200 }} label={t('Type')} InputProps={{ readOnly: true }} />
                            <TextField variant="outlined" value={item?.warrantySubCategory} sx={{ width: 200 }} label={t('Subtype')} InputProps={{ readOnly: true }} />
                            <TextField variant="outlined" value={item?.warrantyType} sx={{ width: 200 }} label={t('category')} InputProps={{ readOnly: true }} />
                            <TextField variant="outlined" value={item?.warrantyAmount} sx={{ width: 110 }} label={t('Amount')} InputProps={{ readOnly: true }} />
                            <TextField variant="outlined" value={item?.currency} sx={{ width: 110 }} label={t('currency')} InputProps={{ readOnly: true }} />
                            {item?.account && <TextField variant="outlined" value={item?.account} sx={{ width: 290 }} label={t('Linked current account')} InputProps={{ readOnly: true }} />}
                            <TextField variant="outlined" value={item?.branchName} sx={{ width: 155 }} label={t('branch')} InputProps={{ readOnly: true }} />
                            {item?.percentRest && <TextField variant="outlined" value={item?.percentRest} sx={{ width: 155 }} label={t('Interest amount')} InputProps={{ readOnly: true }} />}
                            <TextField variant="outlined" value={getFormatedDate(item?.beginDate, 'dd.mm.yyyy')} sx={{ width: 110 }} label={t('Start date')} InputProps={{ readOnly: true }} />
                            <TextField variant="outlined" value={getFormatedDate(item?.endDate, 'dd.mm.yyyy')} sx={{ width: 110 }} label={t('expiration date')} InputProps={{ readOnly: true }} />
                        </Box>
                        {[item?.tenderId, item?.tenderDate, item?.tenderDescription].some(Boolean) && <>
                            <h5>{t('Tender information')}</h5>
                            <Box className='dashboard-account-container-component-block invoice'>
                                <TextField variant="outlined" value={item?.tenderId} sx={{ width: 200 }} label={t('Tender ID')} InputProps={{ readOnly: true }} />
                                <TextField variant="outlined" value={getFormatedDate(item?.tenderDate, 'dd.mm.yyyy')} sx={{ width: 200 }} label={t('date')} InputProps={{ readOnly: true }} />
                                <TextField variant="outlined" value={item?.tenderDescription} sx={{ width: 200 }} label={t('Information')} InputProps={{ readOnly: true }} />
                            </Box>
                        </>}
                        {[item?.contractDate, item?.contractNo].some(Boolean) && <>
                            <Box className='dashboard-account-container-component-block invoice'>
                                <TextField variant="outlined" value={item?.contractNo} sx={{ width: 200 }} label={t('Contract number')} InputProps={{ readOnly: true }} />
                                <TextField variant="outlined" value={getFormatedDate(item?.contractDate, 'dd.mm.yyyy')} sx={{ width: 200 }} label={t('Contract date')} InputProps={{ readOnly: true }} />
                            </Box>
                        </>}
                        {item?.files?.map((item, index) => (
                            <>
                                {index === 0 && <h5>{t('Documents')}</h5>}
                                <Box className="dashboard-account-container-component-block invoice">
                                    <li className="dashboard-file-item" key={index}>
                                        <div className="dashboard-file-item-left">
                                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.09375 14.6562C3.90625 16.4688 6.84375 16.4688 8.65625 14.6562C10.3438 12.9688 13.0938 10.2188 14.7812 8.53125C14.9375 8.375 14.9375 8.15625 14.7812 8L14.25 7.46875C14.0938 7.3125 13.875 7.3125 13.7188 7.46875C12.0312 9.15625 9.28125 11.9062 7.59375 13.5938C6.375 14.8125 4.375 14.8125 3.15625 13.5938C1.9375 12.375 1.9375 10.375 3.15625 9.15625L10.1875 2.125C11 1.3125 12.3125 1.3125 13.125 2.125C13.9375 2.9375 13.9375 4.25 13.125 5.0625L7.21875 10.9688C6.8125 11.375 6.15625 11.375 5.75 10.9688C5.375 10.5938 5.375 9.9375 5.75 9.53125L10.7812 4.53125C10.9375 4.375 10.9375 4.15625 10.7812 4L10.25 3.46875C10.0938 3.3125 9.875 3.3125 9.71875 3.46875L4.71875 8.46875C3.71875 9.46875 3.71875 11.0625 4.71875 12.0312C5.6875 13.0312 7.28125 13.0312 8.25 12.0312L14.1875 6.125C15.5938 4.71875 15.5938 2.46875 14.1875 1.0625C12.7812 -0.34375 10.5312 -0.34375 9.125 1.0625L2.09375 8.09375C0.28125 9.90625 0.28125 12.8438 2.09375 14.6562Z" fill="#849097" />
                                            </svg>
                                            <button type="button" className="dashboard-file-item-title" onClick={() => {
                                                let arrrayBuffer = base64ToArrayBuffer(item.fileContent);
                                                saveFile(item.fileName, `application/${item.fileExtension.split(".").pop()}`, arrrayBuffer)
                                            }}>{item.fileName}</button>
                                        </div>
                                    </li>
                                </Box>
                            </>
                        ))}
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}
export default translate("translation")(GuaranteeDetailsModal);